import React, {useState,useEffect} from 'react'
import { Chart } from "react-google-charts";
import Spinner from 'react-bootstrap/Spinner';
import Container from 'react-bootstrap/Container';
import Label from 'react-bootstrap/FormLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import { Link } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import Accordion from 'react-bootstrap/Accordion';
import { DateRangePicker } from "rsuite";
import ReMultiSelect from 'react-select';
import ReMultiSelectAnimated from 'react-select/animated';
import axios from 'axios';
import Cookies from 'js-cookie';
import {showToast as toast} from '../toastManager.js';
import alasql from 'alasql';
import errorMessages from '../errorMessages.js';
import delete_icon from '../images/bin.png';
import {MultiSelect} from 'react-multi-select-component';

alasql.fn.ReplaceNullValues = function(val){
  return ((val === Infinity) || (val === undefined)) ? 0 : val;
}

alasql.fn.Add_Image_HTML_tag = function(val){
  return `<img src="${val}" alt="Image" width=50 height=50> </img>`;
}


function KeywordLPRelevance({ViewedPage, shop_domain, app_url}) {
    ViewedPage(38);

    const { combine, before, afterToday } = DateRangePicker;
    const max_date = new Date();
    max_date.setDate(max_date.getDate() - 365);

    const [loading, setLoading] = useState(true);
    const [analyze_btn_loading, setAnalyzeBtnLoading] = useState(false);
    const [find_more_variation_loading, setFindMoreVariationsLoading] = useState(false);
    const [generate_btn_loading, setGenerateBtnLoading] = useState(false);
    const [show_landing_page, setShowLandingPageURL] = useState(false);
    const [show_final_landing_page, setShowFinalLandingPageURL] = useState(false);
    const [apply_customization_btn_loading, setApplyCustomizeBtnLoading] = useState(false);
    const [show_advanced_options, setShowAdvancedOptions] = useState(false);
    const [show_top_performing_ad_copies, setShowTopPerformingAdCopies] = useState(false);
    const [is_city_personalization_enabled, setIsCityPersonalizationEnabled] = useState(false);
    const [is_zip_code_personalization_enabled, setIsZipCodePersonalizationEnabled] = useState(false);
    const [spreadsheet_url, setSheetUrl] = useState("");
    const [title_x_axis, setTitleXAxis] = useState("Cost");
    const [title_y_axis, setTitleYAxis] = useState("Clicks");
    const [x_axis, setXAxis] = useState({ value: 'cost', label: 'Cost' });
    const [y_axis, setYAxis] = useState({ value: 'clicks', label: 'Clicks' });
    const [price_range, setPriceRange] = useState([["All","All"]]);
    const [landing_page_exp, setAdStrengthValue] = useState({ value: 'All', label: 'All' });
    const [scattered_plot_type, setScatteredPlotType] = useState("Keyword");
    const [all_keywords, setAllKeywords]  = useState([]);
    const [all_landing_page_urls, setAllLandingPageURLS]  = useState([]);
    const [landing_page_settings, setLandingPageSettings]  = useState({});
    const [selected_keywords, setSelectedKeywords] = useState({"label":"","value":[]});
    const [bulk_apply_selected_keywords, setBulkApplySelectedKeywords] = useState([]);
    const [trashed_keywords, setTrashKeywords] = useState(null);
    const [selected_landing_page_url, setSelectedLandingPageUrl]  = useState("");
    const [scatter_overview_data, setScatterOverviewData] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [selected_suggestion, setSelectedSuggestion] = useState([]);
    const [table_data_level, setTableDataLevel] = useState("Keyword");
    const [custom_input, setCustomInput] = useState([]);
    const [filter_date, setFilterDate] = useState([]);
    const [keyword_level_data, setKeywordLevelData] = useState([]);
    const [ad_group_level_data, setAdGroupLevelData] = useState([]);
    const [best_performing_asset_table_data, setBestPerformingAssetTable] = useState([]);
    
    const [all_metric_json, setAllMetricJson] = useState([]);
    const [current_metric_options, setCurrentMetricOptions] = useState([]);

    const [best_performing_asset_raw_data, setBestPerformingAssetRawData] = useState([]);
    const [keyword_performance_data, setKeywordPerformanceData] = useState([]);
    const [selected_line_chart_keyword_1, setSelectedLineChartsKeywords1] = useState("");
    const [selected_line_chart_metrics_1, setSelectedLineChartsMetrics1] = useState({});
    const [selected_line_chart_keyword_2, setSelectedLineChartsKeywords2] = useState("");
    const [selected_line_chart_metrics_2, setSelectedLineChartsMetrics2] = useState({});
    const [keyword_performance_line_chart_type_1, setKeywordPerformanceLineChartType1] = useState("Keyword");
    const [keyword_performance_line_chart_type_2, setKeywordPerformanceLineChartType2] = useState("Keyword");
    const [keyword_performance_line_chart_all_keywords_1, setKeywordPerformanceLineChartAllKeywords1] = useState([]);
    const [keyword_performance_line_chart_all_keywords_2, setKeywordPerformanceLineChartAllKeywords2] = useState([]);
    const keyword_performance_line_chart_metrics_1 = [
      { value: "SUM(CAST(clicks AS FLOAT))", label: "Clicks" },
      { value: "SUM(CAST(conversions AS FLOAT))", label: "Conv." },
      { value: "SUM(CAST(all_conversions AS FLOAT))", label: "All Conv." },
      { value: "SUM(CAST(conversions_value AS FLOAT))", label: "Conv. value" },
      { value: "SUM(CAST(all_conversions_value AS FLOAT))", label: "All Conv. value" },
      { value: "SUM(CAST(cost AS FLOAT))", label: "Cost" },
      { value: "SUM(CAST(impressions AS FLOAT))", label: "Impr." },
      { value:"SUM(CAST(conversions_value AS FLOAT))/SUM(CAST(cost AS FLOAT))", label:"ROAS"},
      { value:"SUM(CAST(cost AS FLOAT))/SUM(CAST(conversions AS FLOAT))", label:"CPA"},
      { value:"SUM(CAST(conversions AS FLOAT))/SUM(CAST(clicks AS FLOAT))*100", label:"CVR"},
      { value:"SUM(CAST(cost AS FLOAT))/SUM(CAST(clicks AS FLOAT))", label:"CPC"},
      { value:"SUM(CAST(clicks AS FLOAT))/SUM(CAST(impressions AS FLOAT))*100", label:"CTR"},
    ];
    const keyword_performance_line_chart_metrics_2 = [
      { value: "SUM(CAST(clicks AS FLOAT))", label: "Clicks" },
      { value: "SUM(CAST(conversions AS FLOAT))", label: "Conv." },
      { value: "SUM(CAST(all_conversions AS FLOAT))", label: "All Conv." },
      { value: "SUM(CAST(conversions_value AS FLOAT))", label: "Conv. value" },
      { value: "SUM(CAST(all_conversions_value AS FLOAT))", label: "All Conv. value" },
      { value: "SUM(CAST(cost AS FLOAT))", label: "Cost" },
      { value: "SUM(CAST(impressions AS FLOAT))", label: "Impr." },
      { value:"SUM(CAST(conversions_value AS FLOAT))/SUM(CAST(cost AS FLOAT))", label:"ROAS"},
      { value:"SUM(CAST(cost AS FLOAT))/SUM(CAST(conversions AS FLOAT))", label:"CPA"},
      { value:"SUM(CAST(conversions AS FLOAT))/SUM(CAST(clicks AS FLOAT))*100", label:"CVR"},
      { value:"SUM(CAST(cost AS FLOAT))/SUM(CAST(clicks AS FLOAT))", label:"CPC"},
      { value:"SUM(CAST(clicks AS FLOAT))/SUM(CAST(impressions AS FLOAT))*100", label:"CTR"},
    ];
    const [keyword_performance_line_chart_data_1, setKeywordPerformanceLineChartData1] = useState([]);
    const [keyword_performance_line_chart_data_2, setKeywordPerformanceLineChartData2] = useState([]);

    const line_charts_config = {
      chartArea: {'width': '80%', 'height': '70%', 'top':'10%'},
      titleTextStyle : {fontSize: 16},
      hAxis: { 
          format: 'MMM d, y',
          gridlines: {
              color: 'transparent'
          },
      },
      vAxis: {
          format: "short",
          gridlines: {
              color: '#edf1f4',
          },
      },
      // explorer: {
      //     axis: "horizontal",
      //     //   actions: ["dragToZoom", "rightClickToReset"],
      //     keepInBounds: true,
      //     maxZoomIn: 4,
      //     maxZoomOut: 1,
      // },
      legend: "none",
      series: [{'color': '#00b6ef', 'areaOpacity': 0.1}],
      animation: { startup: true, easing: "linear", duration: 1000 },
    };

    useEffect(() => {
      console.log("In Report",shop_domain)
      setLoading(true);
      try {
          if(Cookies.get('shop')){
              // Facebook Loader data
              var created_at_max = new Date();
              created_at_max.setDate(created_at_max.getDate() - 1);
              var created_at_min = new Date(new Date().setDate(created_at_max.getDate() - 90));
              setFilterDate([created_at_min, created_at_max]);
              axios.post(app_url+"/api/google/get_landing_page_optimization_data",{
                  shop_domain:shop_domain,
                  date_start:formatDate(created_at_min),
                  date_end:formatDate(created_at_max),
                  func_call_type:"redis",
              }, {withCredentials:true})
              .then(res => res.data)
              .then(data => {
                  console.log(data)
                  let keyword_level_data = data["data"]["lp_keywords_data"];
                  let ad_group_level_data = data["data"]["lp_ad_group_data"];
                  
                  let temp_all_metrics_json = data["data"]["all_metrics_json"];
                  setAllMetricJson(temp_all_metrics_json);
                  
                  setBestPerformingAssetRawData(data["data"]["landing_page_best_headline_description_data"]);

                  // Settings Location Personalization
                  setIsCityPersonalizationEnabled(data && data?.data && data?.data?.is_city_personalization_enabled ? data["data"]["is_city_personalization_enabled"] : false);
                  setIsZipCodePersonalizationEnabled(data && data?.data && data?.data?.is_zip_code_personalization_enabled ? data["data"]["is_zip_code_personalization_enabled"] : false);

                  let temp_gb_landing_page_settings = data?.data?.gb_landing_page_urls;
                  setLandingPageSettings(temp_gb_landing_page_settings ? temp_gb_landing_page_settings : {})
                  setAllLandingPageURLS(temp_gb_landing_page_settings ? Object.keys(temp_gb_landing_page_settings) : [])
                  setSelectedLandingPageUrl(temp_gb_landing_page_settings ? Object.keys(temp_gb_landing_page_settings)[0] : "")
                  let temp_suggestions_arr = [];
                  if(temp_gb_landing_page_settings){
                    if(Object.keys(temp_gb_landing_page_settings[Object.keys(temp_gb_landing_page_settings)[0]][0]["variation_value"]).includes(selected_keywords["label"])){
                      temp_gb_landing_page_settings[Object.keys(temp_gb_landing_page_settings)[0]][0]["variation_value"][selected_keywords["label"]].forEach((gb_ff_value) => {
                        temp_suggestions_arr.push(gb_ff_value);
                      })
                    }
                    else{
                      temp_gb_landing_page_settings[Object.keys(temp_gb_landing_page_settings)[0]][0]["response_order"].forEach((key) => {
                          temp_suggestions_arr.push("");
                      })
                    }
                  }
                  else{
                    temp_suggestions_arr = [""];
                  }
                  // setSelectedSuggestion(temp_suggestions_arr);

                  let temp_all_keywords = get_all_keywords(keyword_level_data)
                  setKeywordPerformanceLineChartAllKeywords1((temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords : [])
                  setKeywordPerformanceLineChartAllKeywords2((temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords : [])
                  setSelectedLineChartsKeywords1((temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords[0] : "")
                  setSelectedLineChartsKeywords2((temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords[0] : "")
                  setSelectedLineChartsMetrics1({ value: "SUM(CAST(cost AS FLOAT))", label: "Cost" })
                  setSelectedLineChartsMetrics2({ value: "SUM(CAST(cost AS FLOAT))", label: "Cost" })
                  
                  setKeywordLevelData(keyword_level_data);
                  setAdGroupLevelData(ad_group_level_data);
                  setAdGroupLevelData(ad_group_level_data);
                  temp_all_keywords = get_all_keywords_for_analysis_section(keyword_level_data)
                  setAllKeywords((temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords : [])
                  setSelectedKeywords((temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords[0] : {"label": "", "value": []})
                  setScatterOverviewData(get_scatter_overview_data(keyword_level_data, { value: "SUM(CAST(cost AS FLOAT))", label: "Cost" }, { value: "SUM(CAST(clicks AS FLOAT))", label: "Clicks" }, [['All','All']], 'All', "Keyword", temp_all_metrics_json))
                  
                  setAnalyzeBtnLoading(false);
                  setGenerateBtnLoading(false);
                  setShowLandingPageURL(false);
                  setTitleXAxis("Cost");
                  setTitleYAxis("Clicks");
                  setXAxis({ value: "SUM(CAST(cost AS FLOAT))", label: "Cost" });
                  setYAxis({ value: "SUM(CAST(clicks AS FLOAT))", label: "Clicks" });
                  setPriceRange([["All","All"]]);
                  setAdStrengthValue({ value: 'All', label: 'All' });
                  setScatteredPlotType("Keyword");
                  setSuggestions([]);
                  setTableDataLevel("Keyword");
                  setCustomInput("");

                  setLoading(false)
              })
              .catch(err => {
                  setLoading(false)
                  toast.error(`${errorMessages["DATA_PARSING_ERROR"]["title"]}`);
                  console.log(err);
              })


            // axios.post(app_url+"/api/google/get_landing_page_optimization_performance_measurement",{
            //     shop_domain:shop_domain,
            //     date_start:formatDate(created_at_min),
            //     date_end:formatDate(created_at_max),
            //     func_call_type:"redis",
            // }, {withCredentials:true})
            // .then(res => res.data)
            // .then(data => {
            //     console.log(data)
            //     let lp_performance_keywords_data = data["data"]["lp_performance_keywords_data"];
            //     setKeywordPerformanceData(lp_performance_keywords_data)
            //     let temp_all_keywords = get_all_keywords(lp_performance_keywords_data)
            //     setKeywordPerformanceLineChartData1(get_performance_line_chart_data([created_at_min,created_at_max],lp_performance_keywords_data, 'keyword', (temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords[0] : "", { value: "SUM(CAST(cost AS FLOAT))", label: "Cost" }))
            //     setKeywordPerformanceLineChartData2(get_performance_line_chart_data([created_at_min,created_at_max],lp_performance_keywords_data, 'keyword', (temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords[0] : "", { value: "SUM(CAST(cost AS FLOAT))", label: "Cost" }))
            // })
            // .catch(err => {
            //     console.log(err);
            // })
          }
      } catch (error) {
          setLoading(false)
          toast.error(`${errorMessages["DATA_LOAD_ERROR"]["title"]}`);
          console.log(error);
      }

  }, [app_url, shop_domain]);


  const handleDateChange = async (date_range) => {
    setFilterDate(date_range);
    if((date_range !== undefined) && (date_range !== null) && (date_range.length > 0)){
        setLoading(true)
        var created_at_max = formatDate(date_range[1]);
        var created_at_min =  formatDate(date_range[0]);
        axios.post(app_url+"/api/google/get_landing_page_optimization_data",{
          shop_domain:shop_domain,
          date_start:formatDate(created_at_min),
          date_end:formatDate(created_at_max),
          func_call_type:"db",
      }, {withCredentials:true})
      .then(res => res.data)
      .then(data => {
          console.log(data)
          let keyword_level_data = data["data"]["lp_keywords_data"];
          let ad_group_level_data = data["data"]["lp_ad_group_data"];

          let temp_all_metrics_json = data["data"]["all_metrics_json"];
          setAllMetricJson(temp_all_metrics_json);

          setBestPerformingAssetRawData(data["data"]["landing_page_best_headline_description_data"])

          // Settings Location Personalization
          setIsCityPersonalizationEnabled(data && data?.data && data?.data?.is_city_personalization_enabled ? data["data"]["is_city_personalization_enabled"] : false);
          setIsZipCodePersonalizationEnabled(data && data?.data && data?.data?.is_zip_code_personalization_enabled ? data["data"]["is_zip_code_personalization_enabled"] : false);

          let temp_gb_landing_page_settings = data?.data?.gb_landing_page_urls;
          setLandingPageSettings(temp_gb_landing_page_settings ? temp_gb_landing_page_settings : {})
          setAllLandingPageURLS(temp_gb_landing_page_settings ? Object.keys(temp_gb_landing_page_settings) : [])
          setSelectedLandingPageUrl(temp_gb_landing_page_settings ? Object.keys(temp_gb_landing_page_settings)[0] : "")
          let temp_suggestions_arr = [];
          if(temp_gb_landing_page_settings){
            if(Object.keys(temp_gb_landing_page_settings[Object.keys(temp_gb_landing_page_settings)[0]][0]["variation_value"]).includes(selected_keywords["label"])){
              temp_gb_landing_page_settings[Object.keys(temp_gb_landing_page_settings)[0]][0]["variation_value"][selected_keywords["label"]].forEach((gb_ff_value) => {
                temp_suggestions_arr.push(gb_ff_value);
              })
            }
            else{
              temp_gb_landing_page_settings[Object.keys(temp_gb_landing_page_settings)[0]][0]["response_order"].forEach((key) => {
                  temp_suggestions_arr.push("");
              })
            }
          }
          else{
            temp_suggestions_arr = [""];
          }
          // setSelectedSuggestion(temp_suggestions_arr);

          
          let temp_all_keywords = get_all_keywords(keyword_level_data)
          setKeywordPerformanceLineChartAllKeywords1((temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords : [])
          setKeywordPerformanceLineChartAllKeywords2((temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords : [])
          setSelectedLineChartsKeywords1((temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords[0] : "")
          setSelectedLineChartsKeywords2((temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords[0] : "")
          setSelectedLineChartsMetrics1({ value: "SUM(CAST(cost AS FLOAT))", label: "Cost" })
          setSelectedLineChartsMetrics2({ value: "SUM(CAST(cost AS FLOAT))", label: "Cost" })
          
          setKeywordLevelData(keyword_level_data);
          setAdGroupLevelData(ad_group_level_data);
          temp_all_keywords = get_all_keywords_for_analysis_section(keyword_level_data)
          setAllKeywords((temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords : [])
          setSelectedKeywords((temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords[0] : {"label": "", "value": []})
          setScatterOverviewData(get_scatter_overview_data(keyword_level_data, { value: "SUM(CAST(cost AS FLOAT))", label: "Cost" }, { value: "SUM(CAST(clicks AS FLOAT))", label: "Clicks" }, [['All','All']], 'All', "Keyword", temp_all_metrics_json))
          
          setAnalyzeBtnLoading(false);
          setGenerateBtnLoading(false);
          setShowLandingPageURL(false);
          setTitleXAxis("Cost");
          setTitleYAxis("Clicks");
          setXAxis({ value: "SUM(CAST(cost AS FLOAT))", label: "Cost" });
          setYAxis({ value: "SUM(CAST(clicks AS FLOAT))", label: "Clicks" });
          setPriceRange([["All","All"]]);
          setAdStrengthValue({ value: 'All', label: 'All' });
          setScatteredPlotType("Keyword");
          setSuggestions([]);
          setTableDataLevel("Keyword");
          setCustomInput("");

          setLoading(false)
      })
      .catch(err => {
          setLoading(false)
          toast.error(`${errorMessages["DATA_LOAD_ERROR"]["title"]}`);
          console.log(err);
      })

      
      // axios.post(app_url+"/api/google/get_landing_page_optimization_performance_measurement",{
      //     shop_domain:shop_domain,
      //     date_start:formatDate(created_at_min),
      //     date_end:formatDate(created_at_max),
      //     func_call_type:"redis",
      // }, {withCredentials:true})
      // .then(res => res.data)
      // .then(data => {
      //     console.log(data)
      //     let lp_performance_keywords_data = data["data"]["lp_performance_keywords_data"];
      //     setKeywordPerformanceData(lp_performance_keywords_data)
      //     let temp_all_keywords = get_all_keywords(lp_performance_keywords_data)
      //     setKeywordPerformanceLineChartData1(get_performance_line_chart_data([created_at_min,created_at_max],lp_performance_keywords_data, 'keyword', (temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords[0] : "", { value: "SUM(CAST(cost AS FLOAT))", label: "Cost" }))
      //     setKeywordPerformanceLineChartData2(get_performance_line_chart_data([created_at_min,created_at_max],lp_performance_keywords_data, 'keyword', (temp_all_keywords && temp_all_keywords.length > 0) ? temp_all_keywords[0] : "", { value: "SUM(CAST(cost AS FLOAT))", label: "Cost" }))
      // })
      // .catch(err => {
      //     console.log(err);
      // })

    }
  }

    return (
        <div className='main-container'>
            {!shop_domain?
                <div className='go_to_shopify_admin_div'>
                    <h5 style={{display:'inline-block'}}>!! Go to Shopify Admin and open our app !!</h5>
                </div>
                :
                <>
                    { !loading ?
                        <>
                            <div className='main-title mt-4'>
                                <h2>Keyword QS</h2>
                            </div>

                            <Container className='my-4' style={{marginLeft:"0 !important"}}>
                                <Row className='justify-content-md-left' lg={3} xs={1}>
                                    <Col className='p-2'>
                                        <Label className="charts_filter_label">Time Period</Label>
                                        <br />
                                        <DateRangePicker shouldDisableDate={combine(before(max_date), afterToday())} editable={false} value={filter_date} id='date_range' format="yyyy-MM-dd" character=" - " showOneCalendar block onChange={handleDateChange} />
                                    </Col>
                                </Row>
                                <Row className='justify-content-md-left' lg={6} xs={1}>
                                    <Col className='p-2'>
                                        <Label className="charts_filter_label">Data Level</Label>
                                        <ReMultiSelect 
                                            id="data_level"
                                            className='popup_filter_include_exclude'
                                            closeMenuOnSelect={true}
                                            components={ReMultiSelectAnimated()}
                                            value={{ value: scattered_plot_type, label: scattered_plot_type }}
                                            options={[
                                              { value: "Keyword", label: "Keyword" },
                                            ]}
                                            onChange={(selected_vals) => {
                                              setScatteredPlotType(selected_vals.value);
                                              setXAxis({ value: 'cost', label: 'Cost' });
                                              setYAxis({ value: 'clicks', label: 'Clicks' });
                                              setCurrentMetricOptions(all_metric_json);
                                              setAdStrengthValue({ value: 'All', label: 'All' });
                                            }}
                                        />
                                    </Col>
                                    <Col className='p-2'>
                                        <Label className="charts_filter_label">X-Axis</Label>
                                        <ReMultiSelect 
                                            id="x_axis"
                                            className='popup_filter_include_exclude'
                                            closeMenuOnSelect={true}
                                            components={ReMultiSelectAnimated()}
                                            value={x_axis }
                                            options={all_metric_json}
                                            onChange={(selected_vals) => {
                                              setXAxis(selected_vals);
                                            }}
                                        />
                                    </Col>
                                    <Col className='p-2'>
                                        <Label className="charts_filter_label">Y-Axis</Label>
                                        <ReMultiSelect 
                                            id="y_axis"
                                            className='popup_filter_include_exclude'
                                            closeMenuOnSelect={true}
                                            components={ReMultiSelectAnimated()}
                                            value={ y_axis }
                                            options={all_metric_json}
                                            onChange={(selected_vals) => {
                                              setYAxis(selected_vals);
                                            }}
                                        />
                                    </Col>
                                    {/* <Col className='p-2'>
                                        <Label className="charts_filter_label">Cost Filter</Label>
                                        <ReMultiSelect 
                                            className='popup_filter_include_exclude'
                                            closeMenuOnSelect={true}
                                            components={ReMultiSelectAnimated()}
                                            value={[{ value: price_range[0][0] !== "All"? price_range[0][0]+'-'+price_range[0][1] : "All", label: price_range[0][0] !== "All"? price_range[0][0]+'-'+price_range[0][1] : "All" }]}
                                            options={[
                                                { value: 'All', label: 'All' },
                                                { value: '0-50', label: '0-50' },
                                                { value: '50-100', label: '50-100' },
                                                { value: '100-150', label: '100-150' },
                                                { value: '150-200', label: '150-200' },
                                                { value: '200-250', label: '200-250' },
                                                { value: '250-300', label: '250-300' },
                                                { value: '300-350', label: '300-350' },
                                                { value: '350-400', label: '350-400' },
                                                { value: '400-450', label: '400-450' },
                                                { value: '450-500', label: '450-500' },
                                                { value: '500-100000', label: '500+' },
                                            ]}
                                            onChange={(selected_vals) => {
                                                var temp_list = [];
                                                if(selected_vals.value !== "all"){
                                                    temp_list.push([selected_vals.value.split('-')[0], selected_vals.value.split('-')[1]]);
                                                    setPriceRange(temp_list);
                                                }
                                                else{
                                                    setPriceRange(["all","all"]);
                                                }
                                            }}
                                        />
                                    </Col> */}
                                    <Col className='p-2'>
                                        <Label className="charts_filter_label">Landing Page Quality Score</Label>
                                        <ReMultiSelect 
                                            id="y_axis"
                                            className='popup_filter_include_exclude'
                                            closeMenuOnSelect={true}
                                            components={ReMultiSelectAnimated()}
                                            value={landing_page_exp}
                                            options={[
                                                { value: 'All', label: 'All' },
                                                { value: 'BELOW_AVERAGE', label: 'Below average' },
                                                { value: 'AVERAGE', label: 'Average' },
                                                { value: 'ABOVE_AVERAGE', label: 'Above average' },
                                            ]}
                                            onChange={(selected_vals) => {
                                              setAdStrengthValue(selected_vals);
                                            }}
                                        />
                                    </Col>
                                    <Col className='p-2 d-flex align-items-end'>
                                        <Button className='d-flex align-items-center justify-content-center sxi_primary_blue_btn' onClick={() => {
                                            setLoading(true);
                                            setTimeout(()=> {
                                              setTitleXAxis(x_axis["label"])
                                              setTitleYAxis(y_axis["label"])
                                              setScatterOverviewData(get_scatter_overview_data(scattered_plot_type === "Keyword" ? keyword_level_data : ad_group_level_data, x_axis, y_axis, price_range, landing_page_exp.value, scattered_plot_type, all_metric_json))
                                              setLoading(false);
                                            }, 100)
                                        }}>Apply</Button>
                                    </Col>
                                </Row>
                            </Container>

                            <div className='cro-overview mb-5'>
                                { scatter_overview_data.length > 0 ?
                                    <Chart
                                        chartType="ScatterChart"
                                        width="100%"
                                        height="500px"
                                        data={scatter_overview_data}
                                        options={{
                                            pointSize:10,
                                            chartArea: {
                                                width: "70%",
                                                height: "80%"
                                            },
                                            hAxis: { 
                                                title:title_x_axis,
                                                viewWindow: {
                                                    min: 0
                                                },
                                                gridlines: {
                                                    color: '#e7e7e7',
                                                },
                                            },
                                            vAxis: {
                                              title:title_y_axis,
                                                viewWindow: {
                                                    min: 0
                                                },
                                                gridlines: {
                                                    color: '#e7e7e7',
                                                },
                                            },
                                            curveType: "function",
                                            tooltip: { isHtml: true },
                                            legend: {
                                              alignment: 'center',
                                              
                                            },
                                            series: [
                                              { color: 'darkgreen', labelInLegend: 'Above average' },
                                              { color: 'red', labelInLegend: 'Below average' },
                                              { color: '#e9eb38', labelInLegend: 'Average' },
                                              { color: 'orange', labelInLegend: '--' },
                                            ]
                                        }}
                                    />
                                    :
                                    "No data to Show."
                                }
                            </div>
                        </>
                        :
                        <div className='main_conatiner_spinner'>
                            <Spinner animation="border"/>
                        </div>
                    }
                </>
            }
        </div>
    )

}

export default KeywordLPRelevance


function jsonToArrayObject(res, graph_columns) {
  var columns = Object.keys(res[0]);
  var resultArray = res.map(function (obj) {
    var res_arr = [];
    for (let column_name of columns) {
      switch (obj[column_name]) {
        case 'Infinity':
        case 'NaN':
        case '-Infinity':
        case Infinity:
        case -Infinity:
          res_arr.push(0);
          break;
          
        default:
          res_arr.push(obj[column_name]);
          break;
      }
    }
    return res_arr;
  });
  resultArray.unshift(graph_columns)
  console.log(resultArray)
 return resultArray;
}


function get_all_keywords(keyword_level_data){
  var res = alasql(`SELECT * FROM ? ORDER BY keyword_text DESC`, [keyword_level_data]);
  res = alasql(`SELECT ARRAY(DISTINCT keyword_text) as all_keywords FROM ?`, [res]);
  console.log(res[0]["all_keywords"]);
  return res[0]["all_keywords"];
}

function get_all_keywords_for_analysis_section(keyword_level_data){
  var res = alasql(`SELECT * FROM ? ORDER BY keyword_text DESC`, [keyword_level_data]);
//   res = alasql(`SELECT ARRAY(DISTINCT keyword_text) as all_keywords FROM ?`, [res]);
//   console.log(res[0]["all_keywords"]);
//   return res[0]["all_keywords"];


  // Map each record to the desired string format
  var combined_json = [];
  // Single keywords, multiple values (campaign level, adgroup level)
  // res.forEach(row => 
  //   {
  //     let keyword_exists = combined_json.filter((item) => item["label"] === row["keyword_text"])
  //     if(keyword_exists.length > 0){
  //       keyword_exists[0]["value"].push({"campaign_id":row.campaign_id, "campaign_name":row.campaign_name, "ad_group_id":row.ad_group_id, "ad_group_name":row.ad_group_name, keyword_text:row.keyword_text,match_type:row.match_type});
  //     }
  //     else{
  //       combined_json.push({"label": row["keyword_text"], "value": [{"campaign_id":row.campaign_id, "campaign_name":row.campaign_name, "ad_group_id":row.ad_group_id, "ad_group_name":row.ad_group_name, keyword_text:row.keyword_text,match_type:row.match_type}]});
  //     }
  //   }
  // );

  // Single Value for all
  res.forEach(row => 
    {
      combined_json.push({"label": row["keyword_text"], "value": [{"campaign_id":row.campaign_id, "campaign_name":row.campaign_name, "ad_group_id":row.ad_group_id, "ad_group_name":row.ad_group_name, keyword_text:row.keyword_text,match_type:row.match_type}]})
    }
  );

  // Remove duplicates if needed
  var uniqueCombinedStrings = [...new Set(combined_json)];

  return uniqueCombinedStrings;
}


function get_scatter_overview_data(keyword_level_data, x_axis, y_axis, price_range, landing_page_exp, scattered_plot_type, all_metrics){
    var filtered_data = alasql(`SELECT campaign_name, ad_group_name, keyword_text, match_type, post_click_quality_score, ${all_metrics.map((item, index) => {return  item["value"]+" as ["+item["label"]+"]"}).join(", ")} FROM ? GROUP BY campaign_name, ad_group_name, keyword_text, match_type, post_click_quality_score`,[keyword_level_data]);
    
    let scattered_plot_metrics = all_metrics.filter(item => ["Clicks","Conv.","Conv. value","Cost","Impr.","CPA","CVR","CPC","CTR"].includes(item["label"]));

    // if(price_range.length > 0){
    //   for(let price of price_range){
    //     if( price[0] !== "All"){
    //       filtered_data = alasql(`SELECT * FROM ? WHERE (([cost] >= ${price[0]}) AND ([cost] <= ${price[1]}))`, [filtered_data]);
    //     }
    //   }
    // }
    
    if(landing_page_exp !== "All"){
      filtered_data = alasql(`SELECT * FROM ? WHERE [post_click_quality_score] = '${landing_page_exp}'`, [filtered_data]);
    }
    

    var res = alasql(`SELECT * FROM ?`, [filtered_data]);
    if(res.length > 0){
      var final_res = [[{label:x_axis["label"],type:"number"},{label:"Above average",type:"number"}, {type:'string','role': 'tooltip', 'p': {'html': true}}, {label:"Below average",type:"number"}, {type:'string','role': 'tooltip', 'p': {'html': true}}, {label:"Average",type:"number"}, {type:'string','role': 'tooltip', 'p': {'html': true}}, {label:"--",type:"number"}, {type:'string','role': 'tooltip', 'p': {'html': true}}]]
      for(let obj of res ){
          final_res.push([
              obj[x_axis["label"]],
              
              obj["post_click_quality_score"] === "ABOVE_AVERAGE" ? obj[y_axis["label"]] : null,
              `
              <div style="background-color:white; padding:20px; width:20rem; border-radius:5px; box-shadow:0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)">
                  <p style="margin:3px; font-size:medium;">Keyword : <b>${obj["keyword_text"] ? obj["keyword_text"].replaceAll("_"," ") : ""}</b></p>
                  <p style="margin:3px; font-size:medium;">Match type : <b>${obj["match_type"] ? obj["match_type"].replaceAll("_"," ") : ""}</b></p>
                  <p style="margin:3px; font-size:medium;">Campaign Name : <b>${obj["campaign_name"] ? obj["campaign_name"].replaceAll("_"," ") : ""}</b></p>
                  <p style="margin:3px; font-size:medium;">Ad Group Name : <b>${obj["ad_group_name"] ? obj["ad_group_name"].replaceAll("_"," ") : ""}</b></p>
                  <p style="margin:3px; font-size:medium;">Landing Page Quality Score : <b>Above average</b></p>
                  <br>
                  ${scattered_plot_metrics.map((item, index) => {
                    return '<p style="margin:3px; font-size:medium;">'+ item["label"] +': <b>'+parseFloat(parseFloat((obj[item["label"]] && obj[item["label"]] !== Infinity && obj[item["label"]] !== -Infinity)? obj[item["label"]] : 0)).toLocaleString('en-US', {minimumFractionDigits: 1,maximumFractionDigits: 1})+(["CVR","CTR"].includes(item["label"]) ? '%' : '')+'</b></p>';
                  }).join('\n')}
              </div>
              `,
                obj["post_click_quality_score"] === "BELOW_AVERAGE" ? obj[y_axis["label"]] : null,
                `
              <div style="background-color:white; padding:20px; width:20rem; border-radius:5px; box-shadow:0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)">
                  <p style="margin:3px; font-size:medium;">Keyword : <b>${obj["keyword_text"] ? obj["keyword_text"].replaceAll("_"," ") : ""}</b></p>
                  <p style="margin:3px; font-size:medium;">Match type : <b>${obj["match_type"] ? obj["match_type"].replaceAll("_"," ") : ""}</b></p>
                  <p style="margin:3px; font-size:medium;">Campaign Name : <b>${obj["campaign_name"] ? obj["campaign_name"].replaceAll("_"," ") : ""}</b></p>
                  <p style="margin:3px; font-size:medium;">Ad Group Name : <b>${obj["ad_group_name"] ? obj["ad_group_name"].replaceAll("_"," ") : ""}</b></p>
                  <p style="margin:3px; font-size:medium;">Landing Page Quality Score : <b>Below average</b></p>
                  <br>
                  ${scattered_plot_metrics.map((item, index) => {
                    return '<p style="margin:3px; font-size:medium;">'+ item["label"] +': <b>'+parseFloat(parseFloat((obj[item["label"]] && obj[item["label"]] !== Infinity && obj[item["label"]] !== -Infinity)? obj[item["label"]] : 0)).toLocaleString('en-US', {minimumFractionDigits: 1,maximumFractionDigits: 1})+(["CVR","CTR"].includes(item["label"]) ? '%' : '')+'</b></p>';
                  }).join('\n')}
              </div>
              `,

                obj["post_click_quality_score"] === "AVERAGE" ? obj[y_axis["label"]] : null,              
                `
              <div style="background-color:white; padding:20px; width:20rem; border-radius:5px; box-shadow:0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)">
                  <p style="margin:3px; font-size:medium;">Keyword : <b>${obj["keyword_text"] ? obj["keyword_text"].replaceAll("_"," ") : ""}</b></p>
                  <p style="margin:3px; font-size:medium;">Match type : <b>${obj["match_type"] ? obj["match_type"].replaceAll("_"," ") : ""}</b></p>
                  <p style="margin:3px; font-size:medium;">Campaign Name : <b>${obj["campaign_name"] ? obj["campaign_name"].replaceAll("_"," ") : ""}</b></p>
                  <p style="margin:3px; font-size:medium;">Ad Group Name : <b>${obj["ad_group_name"] ? obj["ad_group_name"].replaceAll("_"," ") : ""}</b></p>
                  <p style="margin:3px; font-size:medium;">Landing Page Quality Score : <b>Average</b></p>
                  <br>
                  ${scattered_plot_metrics.map((item, index) => {
                    return '<p style="margin:3px; font-size:medium;">'+ item["label"] +': <b>'+parseFloat(parseFloat((obj[item["label"]] && obj[item["label"]] !== Infinity && obj[item["label"]] !== -Infinity)? obj[item["label"]] : 0)).toLocaleString('en-US', {minimumFractionDigits: 1,maximumFractionDigits: 1})+(["CVR","CTR"].includes(item["label"]) ? '%' : '')+'</b></p>';
                  }).join('\n')}
              </div>
              `,

                (obj["post_click_quality_score"] === "--") || (obj["post_click_quality_score"] === "nan") ? obj[y_axis["label"]] : null,
                `
              <div style="background-color:white; padding:20px; width:20rem; border-radius:5px; box-shadow:0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)">
                  <p style="margin:3px; font-size:medium;">Keyword : <b>${obj["keyword_text"] ? obj["keyword_text"].replaceAll("_"," ") : ""}</b></p>
                  <p style="margin:3px; font-size:medium;">Match type : <b>${obj["match_type"] ? obj["match_type"].replaceAll("_"," ") : ""}</b></p>
                  <p style="margin:3px; font-size:medium;">Campaign Name : <b>${obj["campaign_name"] ? obj["campaign_name"].replaceAll("_"," ") : ""}</b></p>
                  <p style="margin:3px; font-size:medium;">Ad Group Name : <b>${obj["ad_group_name"] ? obj["ad_group_name"].replaceAll("_"," ") : ""}</b></p>
                  <p style="margin:3px; font-size:medium;">Landing Page Quality Score : <b>--</b></p>
                  <br>
                  ${scattered_plot_metrics.map((item, index) => {
                    return '<p style="margin:3px; font-size:medium;">'+ item["label"] +': <b>'+parseFloat(parseFloat((obj[item["label"]] && obj[item["label"]] !== Infinity && obj[item["label"]] !== -Infinity)? obj[item["label"]] : 0)).toLocaleString('en-US', {minimumFractionDigits: 1,maximumFractionDigits: 1})+(["CVR","CTR"].includes(item["label"]) ? '%' : '')+'</b></p>';
                  }).join('\n')}
              </div>
              `]);
      }
      return final_res;
    }
    return [[{label:x_axis["label"],type:"number"},{label:"Above average",type:"number"}, {type:'string','role': 'tooltip', 'p': {'html': true}}, {label:"Below average",type:"number"}, {type:'string','role': 'tooltip', 'p': {'html': true}}, {label:"Average",type:"number"}, {type:'string','role': 'tooltip', 'p': {'html': true}}, {label:"--",type:"number"}, {type:'string','role': 'tooltip', 'p': {'html': true}}]];
}


function get_filter_date_from_data(data){
  let min_max_date_dict = alasql(`SELECT MIN(DATE(date_start)) as min_date, MAX(DATE(date_start)) as max_date FROM ?`,[data])[0];
  return [min_max_date_dict["min_date"], min_max_date_dict["max_date"]];
}


function formatDate(date, is_increase_date=false) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + (is_increase_date? d.getDate() + 1: d.getDate()),
    year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return [year, month, day].join('-');
}


function check_loc_personalization(query) {
  const pattern = /\{\s*(\w+)?\s*(sxi_city|sxi_zipcode)(?:\s*:\s*([^}]+))?\s*\}/i;

  const match = query.match(pattern);

  if (match) {
    const key = match[2];
    return {
      is_loc_personalized: true,
      loc_personalization_type: key === "sxi_city" ? "city" : "zip_code"
    };
  } else {
    return {
      is_loc_personalized: false,
      loc_personalization_type: null
    };
  }
}


function get_performance_line_chart_data(dateRange, lp_performance_data, data_level, keywords, metrics) {
  // First filter by keyword
  let res = alasql(`SELECT * FROM ? WHERE keyword_text = "${keywords}"`,[lp_performance_data]);
  if(res.length === 0) {
    return []
  }
  const metricValue = `CASE 
    WHEN ${metrics["value"]} = 'Infinity' THEN 0 
    WHEN ${metrics["value"]} IS NULL THEN 0
    WHEN ${metrics["value"]} = 'NaN' THEN 0
    ELSE COALESCE(${metrics["value"]}, 0) 
  END`;

  // Get the metrics data grouped by date
  res = alasql(`
    SELECT DATE(date) as date, ${metricValue} AS [${metrics["label"]}]
    FROM ?
    WHERE DATE(date) >= DATE('${formatDate(dateRange[0])}')
    AND DATE(date) <= DATE('${formatDate(dateRange[1])}')
    GROUP BY date
  `, [res]);

  // Generate all dates between start and end
  const allDates = [];
  const start = new Date(dateRange[0]);
  const end = new Date(dateRange[1]);
  
  const currentDate = new Date(start);
  while (currentDate <= end) {
    const dateStr = currentDate.toISOString().split('T')[0];
    
    // Find if we have a value for this date
    const existingRecord = res.find(item => item.date.toISOString().split('T')[0] === dateStr);

    allDates.push({
      date: new Date(dateStr),
      [metrics.label]: existingRecord ? existingRecord[metrics.label] : 0
    });
    
    currentDate.setDate(currentDate.getDate() + 1);
  }

  if(allDates.length === 0) {
    return []
  }
  
  return jsonToArrayObject(allDates, [{"type":"date","label":"Date"}, metrics["label"]]);
}